export default {
  "app.title": "AICOS",
  "app.tagline": "Finanzas",
  "nav.dashboard": "Panel",
  "nav.gl": "Libro mayor",
  "nav.ar": "Cuentas por cobrar",
  "nav.ap": "Cuentas por pagar",
  "nav.tax": "Impuestos",
  "auth.signIn": "Iniciar sesión",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.signOut": "Cerrar sesión",
  "auth.invalid": "Correo o contraseña inválidos",
  "auth.signedInAs": "Sesión iniciada como",
  "dashboard.welcome": "Bienvenido a AICOS",
  "nav.bi": "Facturación",
  "nav.po": "Compras",
  "nav.ex": "Gastos",
  "nav.entities": "Entidades",
  "dashboard.subtitle": "Consola de operador — cada acción de módulo, conectada a AICOS.",
  "nav.ceo": "Cabina CEO",
  "nav.cfo": "Rincón CFO",
  "kpi.days": "días",
  "nav.compliance": "Cumplimiento",
  "brand.org": "Lopettia",
  "brand.product": "AICOS",
  "nav.home": "Inicio",
  "app.system": "Sistema Operativo Corporativo con IA",
  "home.selectModule": "Seleccione un módulo",
  "Tour": "Tour",
  "Manual": "Manual",
  "soon.title": "Próximamente",
  "soon.body": "Esta función forma parte del alcance de paridad del AICOS legacy y todavía no está conectada en el rewrite en Go. Sigue disponible en el AICOS legacy.",
  "mod.ap": "Cuentas por pagar",
  "mod.ar": "Cuentas por cobrar",
  "mod.ex": "Viajes y gastos",
  "hub.journals": "Asientos",
  "hub.reports": "Saldos e informes",
  "hub.closing": "Cierre",
  "hubd.newJournal": "Crear y editar asientos manuales",
  "hubd.journals": "Contabilizar, aprobar y reversar",
  "hubd.trialBalance": "Saldos de cuentas del año",
  "hubd.statements": "Balance general y estado de resultados",
  "hubd.yearEnd": "Proceso de cierre anual",
  "hubd.payables": "Registrar y contabilizar una factura de proveedor",
  "hubd.payablesList": "Facturas de proveedor contabilizadas",
  "hubd.receivables": "Emitir una factura de cliente",
  "hubd.openItems": "Cuentas por cobrar pendientes",
  "hubd.payment": "Recibir y aplicar un pago",
  "hubd.billing": "Emitir una factura de venta con GST",
  "hubd.invoices": "Facturas de venta emitidas",
  "hubd.purchasing": "Crear una orden de compra",
  "hubd.orders": "Órdenes de compra abiertas",
  "hubd.match": "Conciliación de 3 vías con CxP",
  "hubd.expenses": "Enviar un informe de gastos",
  "hubd.expenseList": "Aprobar y contabilizar informes",
  "kpi.revenue_ytd": "Ingresos del año",
  "kpi.expenses_ytd": "Gastos del año",
  "kpi.net_income": "Utilidad neta",
  "kpi.operating_margin_pct": "Margen operativo",
  "kpi.gross_margin_pct": "Margen bruto",
  "kpi.cash_position": "Posición de caja",
  "kpi.ar_balance": "Cuentas por cobrar",
  "kpi.ap_balance": "Cuentas por pagar",
  "kpi.gst_net_owing": "IVA neto a pagar",
  "kpi.working_capital": "Capital de trabajo",
  "kpi.current_ratio": "Razón corriente",
  "kpi.dso_days": "DSO",
  "kpi.dpo_days": "DPO",
  "kpi.dio_days": "DIO",
  "kpi.ccc_days": "Ciclo de conversión de efectivo",
  "kpi.revenue_mtd": "Ingresos del mes",
  "kpi.bills_mtd_count": "Facturas del mes",
  "kpi.pipeline_value": "Valor del pipeline",
  "kpi.concentration_top1_pct": "Concentración del cliente principal",
  "kpi.active_business_units": "Unidades de negocio activas",
  "kpi.active_users": "Usuarios activos",
  "kpi.risk_score": "Hallazgos de auditoría abiertos",
  "kpi.top_customers": "Principales clientes",
  "kpi.geographic_top": "Región principal",
  "dash.openItemsFor": "Partidas abiertas — {id}",
  "dash.openFindings": "Hallazgos de auditoría abiertos",
  "common.date": "Fecha",
  "common.currency": "Moneda",
  "common.description": "Descripción",
  "common.amount": "Importe",
  "common.account": "Cuenta",
  "common.debit": "Débito",
  "common.credit": "Crédito",
  "common.status": "Estado",
  "common.actions": "Acciones",
  "common.customer": "Cliente",
  "common.vendor": "Proveedor",
  "common.total": "Total",
  "common.calculate": "Calcular",
  "common.result": "Resultado",
  "common.rate": "Tasa",
  "common.language": "Idioma",
  "common.noData": "Sin datos.",
  "common.selectAccount": "Seleccionar cuenta…",
  "common.selectCustomer": "Seleccionar cliente…",
  "common.selectVendor": "Seleccionar proveedor…",
  "common.remove": "Quitar",
  "gl.tab.entry": "Nuevo asiento",
  "gl.tab.journals": "Asientos",
  "gl.tab.balances": "Saldos",
  "gl.tab.reports": "Informes",
  "gl.tab.yearend": "Cierre anual",
  "gl.yearEnd": "Cierre de fin de año",
  "gl.previewClose": "Previsualizar cierre",
  "gl.executeClose": "Ejecutar cierre",
  "gl.closingLines": "líneas de cierre",
  "gl.closed": "Año fiscal {fy} cerrado (asiento {id}).",
  "gl.exportCsv": "Exportar CSV",
  "common.fiscalYear": "Año fiscal",
  "gl.descrPlaceholder": "p. ej. Ingresos mensuales de consultoría",
  "gl.addLine": "+ Agregar línea",
  "gl.balanced": "Cuadrado",
  "gl.outOfBalance": "Descuadre: {diff}",
  "gl.saveDraft": "Guardar borrador",
  "gl.postJournal": "Contabilizar asiento",
  "gl.posted": "Asiento {id} contabilizado.",
  "gl.savedDraft": "Asiento {id} guardado como borrador.",
  "gl.approved": "Asiento {id} aprobado.",
  "gl.col.journal": "Asiento",
  "gl.noJournals": "Aún no hay asientos. Cree uno en «Nuevo asiento».",
  "gl.post": "Contabilizar",
  "gl.approve": "Aprobar",
  "gl.reverse": "Reversar",
  "gl.reversed": "Asiento {id} reversado.",
  "gl.reverseReason": "Motivo de la reversión (mín. 10 caracteres)",
  "common.cancel": "Cancelar",
  "gl.balancesTitle": "Saldos de cuentas (EF {fy})",
  "gl.noBalances": "Aún no hay saldos contabilizados.",
  "gl.col.debits": "Débitos",
  "gl.col.credits": "Créditos",
  "gl.col.balance": "Saldo",
  "gl.balanceSheet": "Balance general (EF {fy})",
  "gl.incomeStatement": "Estado de resultados (EF {fy})",
  "gl.assets": "Activos",
  "gl.totalAssets": "Total de activos",
  "gl.liabilities": "Pasivos",
  "gl.equity": "Patrimonio",
  "gl.netIncomeYear": "Utilidad neta del ejercicio",
  "gl.totalLiabEquity": "Total pasivos y patrimonio",
  "gl.isBalanced": "✓ Cuadrado",
  "gl.notBalanced": "⚠ Descuadrado",
  "gl.revenue": "Ingresos",
  "gl.totalRevenue": "Total de ingresos",
  "gl.expenses": "Gastos",
  "gl.totalExpenses": "Total de gastos",
  "gl.netIncome": "Utilidad neta",
  "ar.newInvoice": "Nueva factura de cliente",
  "ar.createInvoice": "Crear factura",
  "ar.created": "Factura {id} creada.",
  "ar.openItems": "Partidas abiertas",
  "ar.noItems": "Sin partidas abiertas.",
  "ar.openItem": "Partida abierta",
  "ar.selectItem": "Seleccionar una partida",
  "ar.paymentAmount": "Monto del pago",
  "ar.cashAccount": "Cuenta de efectivo",
  "ar.receivePayment": "Recibir pago",
  "ar.receiveApply": "Recibir y aplicar",
  "ar.paymentPosted": "Pago aplicado a {id}.",
  "ar.col.item": "Partida",
  "ar.col.balance": "Saldo",
  "ap.enterBill": "Registrar una factura",
  "ap.vendorInvoice": "N.º factura proveedor",
  "ap.expenseAccount": "Cuenta de gastos",
  "ap.enterPost": "Registrar y contabilizar",
  "ap.posted": "Factura {id} registrada y contabilizada.",
  "ap.bills": "Facturas",
  "ap.noBills": "Sin facturas.",
  "ap.col.voucher": "Comprobante",
  "ap.col.gross": "Bruto",
  "ap.col.net": "Neto",
  "bi.issueInvoice": "Emitir factura de venta",
  "bi.revenueAccount": "Cuenta de ingresos",
  "bi.amountBeforeTax": "Importe (antes de impuestos)",
  "bi.gst": "GST/HST",
  "bi.issue": "Emitir factura",
  "bi.issued": "Factura {id} emitida (contabiliza ingresos + abre una cuenta por cobrar).",
  "bi.invoices": "Facturas",
  "bi.noInvoices": "Sin facturas.",
  "bi.col.invoice": "Factura",
  "ex.newReport": "Nuevo informe de gastos",
  "ex.employee": "Empleado",
  "ex.employeePlaceholder": "ID de empleado",
  "ex.purpose": "Propósito",
  "ex.submit": "Enviar informe",
  "ex.approve": "Aprobar",
  "ex.approved": "Informe {id} aprobado.",
  "ex.post": "Contabilizar",
  "ex.posted": "Informe {id} contabilizado.",
  "ex.submitted": "Informe {id} enviado (apruebe y luego contabilice en Asientos).",
  "ex.reports": "Informes",
  "ex.noReports": "Sin informes de gastos.",
  "ex.col.report": "Informe",
  "ex.col.reimbursable": "Reembolsable",
  "po.newOrder": "Nueva orden de compra",
  "po.quantity": "Cantidad",
  "po.unitPrice": "Precio unitario",
  "po.create": "Crear orden",
  "po.created": "Orden de compra {id} creada.",
  "po.orders": "Órdenes de compra",
  "po.noOrders": "Sin órdenes de compra.",
  "po.receive": "Recibir",
  "po.received": "Mercancía recibida para la OC {po}.",
  "po.noLines": "Esta OC no tiene líneas.'",
  "po.col.po": "Orden",
  "po.col.match": "Conciliación",
  "po.threeWayMatch": "Conciliación de 3 vías",
  "po.matchResult": "Orden {po}: {status}.",
  "ent.title": "Datos de referencia",
  "ent.chartOfAccounts": "Plan de cuentas",
  "ent.customers": "Clientes",
  "ent.vendors": "Proveedores",
  "ent.currencies": "Monedas",
  "ent.provinces": "Provincias",
  "ent.noRows": "Sin filas.",
  "ent.new": "Nuevo registro",
  "ent.create": "Crear",
  "ent.created": "Registro creado.",
  "ent.delete": "Eliminar",
  "ent.deleted": "Registro eliminado.",
  "ent.confirmDelete": "�Eliminar este registro?",
  "ent.grp.master": "Datos maestros",
  "ent.grp.collections": "Cobranzas CxC",
  "ent.grp.expense": "Detalle de gastos",
  "ent.grp.compliance": "Cumplimiento y divulgación",
  "ent.arWriteoffs": "Castigos CxC",
  "ent.arAllowance": "Provisión CxC (CECL)",
  "ent.dunning": "Cartas de cobranza",
  "ent.travelAuth": "Autorizaciones de viaje",
  "ent.cashAdvance": "Anticipos de efectivo",
  "ent.auditFindings": "Hallazgos de auditoría interna",
  "ent.legalHold": "Retenciones legales",
  "ent.consolidation": "Eliminaciones de consolidación",
  "tax.title": "Impuestos — Canadá (Alberta)",
  "tax.tab.gst": "Calculadora GST",
  "tax.tab.return": "Declaración GST/HST",
  "tax.tab.rates": "Tasas",
  "tax.calcTitle": "Calcular GST/HST",
  "tax.amountBeforeTax": "Importe (antes de impuestos)",
  "tax.province": "Provincia",
  "tax.transaction": "Transacción",
  "tax.txSale": "Venta (cobrar GST)",
  "tax.txPurchase": "Compra (crédito fiscal)",
  "tax.supply": "Suministro",
  "tax.domestic": "Nacional",
  "tax.export": "Exportación a no residente",
  "tax.taxClass": "Clase de impuesto",
  "tax.itc": "Crédito fiscal",
  "tax.yes": "Sí (recuperable)",
  "tax.no": "No",
  "tax.returnTitle": "Declaración GST/HST",
  "tax.english": "Inglés",
  "tax.french": "Francés",
  "tax.line": "Línea {n} — {label}",
  "tax.netTax": "Impuesto neto",
  "tax.ratesTitle": "Tasas de impuesto a las ventas de Canadá",
  "tax.col.gstHst": "GST/HST",
  "tax.col.pst": "PST",
  "tax.col.type": "Tipo",
  "comp.amount": "Importe",
  "comp.grossAmount": "Importe bruto",
  "comp.province": "Provincia",
  "comp.transaction": "Transacción",
  "comp.supply": "Suministro",
  "comp.class": "Clase",
  "comp.concept": "Concepto",
  "comp.municipality": "Municipio",
  "comp.taxableIncome": "Renta gravable",
  "comp.tariff": "Tarifa",

  // ── Hub card titles + module subtitles (keyed by English string) ──
  "Configuration": "Configuración",
  "Journals": "Asientos",
  "Reconciliation": "Conciliación",
  "Multi-currency": "Multimoneda",
  "Consolidation": "Consolidación",
  "Closing": "Cierre",
  "Reports": "Reportes",
  "Inquiries": "Consultas",
  "Puerto Rico": "Puerto Rico",
  "Administration": "Administración",
  "Vendors": "Proveedores",
  "Vouchers": "Comprobantes",
  "Payments": "Pagos",
  "Withholding": "Retenciones",
  "Customers": "Clientes",
  "Pending Items": "Partidas pendientes",
  "Adjustments": "Ajustes",
  "Collections": "Cobranza",
  "Items": "Artículos",
  "Requisitions": "Requisiciones",
  "Quotations (RFQ)": "Cotizaciones (RFQ)",
  "Purchase Orders": "Órdenes de compra",
  "Receiving": "Recepción",
  "Contracts": "Contratos",
  "Budget": "Presupuesto",
  "My Expenses (Self-Service)": "Mis gastos (autoservicio)",
  "Delegated Entry": "Captura delegada",
  "Approvals": "Aprobaciones",
  "Accounting": "Contabilidad",
  "Processes": "Procesos",
  "Consolidated Invoices": "Facturas consolidadas",
  "WorkCenter": "WorkCenter",
  "Invoices": "Facturas",
  "Multi-ledger chart of accounts, journals with approval, multicurrency, consolidation and close.": "Plan de cuentas multi-libro, asientos con aprobación, multimoneda, consolidación y cierre.",
  "Vendors, vouchers with 3-way match, pay cycles, withholding (PR Sec. 1062 + Form 480 + US 1099). Automatic GL integration.": "Proveedores, comprobantes con conciliación de 3 vías, ciclos de pago, retenciones (PR Sec. 1062 + Forma 480 + US 1099). Integración automática con el mayor.",
  "Customers shared with BI, pending items, deposits and application worksheets, aging and dunning. Zero re-entry.": "Clientes compartidos con facturación, partidas pendientes, depósitos y hojas de aplicación, antigüedad y cobranza. Sin reingreso.",
  "Bill types, charge codes with classified IVU (PR), bill cycles, entry and auto-bill-to-AR. SURI integration ready.": "Tipos de factura, conceptos con IVU clasificado (PR), ciclos de facturación, captura y auto-factura a CxC. Listo para SURI.",
  "Requisitions, purchase orders, receipts, contracts. 3-way match with AP. Integrated Req→PO→Receipt→Voucher flow.": "Requisiciones, órdenes de compra, recepciones, contratos. Conciliación de 3 vías con CxP. Flujo integrado Req→OC→Recepción→Comprobante.",
  "Travel Auth, Cash Advance, Expense Report with approval and audit. Integrates GL, AP and corporate card.": "Autorización de viaje, anticipo de efectivo, informe de gastos con aprobación y auditoría. Integra mayor, CxP y tarjeta corporativa.",

  // ── CEO / CFO cockpits ──
  "Strategic view · 8 KPIs · click a tile to drill down.": "Vista estratégica · 8 KPIs · haga clic en un mosaico para profundizar.",
  "Financial view · 12 KPIs · working capital + close + SOX + tax.": "Vista financiera · 12 KPIs · capital de trabajo + cierre + SOX + impuestos.",
  "Strategic": "Estratégico",
  "Close Calendar": "Calendario de cierre",
  "Working Capital": "Capital de trabajo",
  "Current Ratio": "Razón corriente",
  "P&L vs Budget": "Resultados vs presupuesto",
  "13-Week Cash": "Caja a 13 semanas",
  "Tax Provision": "Provisión de impuestos",
  "SOX Status": "Estado SOX",
  "AR Aging": "Antigüedad CxC",
  "AP Aging": "Antigüedad CxP",
  "Material Weakness": "Debilidad material",
  "target": "objetivo",
  "Click for detail": "Clic para detalle",
  "Period insights (auto-generated)": "Perspectivas del período (auto-generadas)",
  "All key indicators within target.": "Todos los indicadores clave dentro del objetivo.",
  "AR Aging Distribution": "Distribución de antigüedad CxC",
  "Current": "Corriente",
  "Close accounting actions": "Acciones contables del cierre",
  "Revenue billed this month": "Ingresos facturados este mes",
  "(Revenue − OpEx) / Revenue, YTD": "(Ingresos − gasto operativo) / Ingresos, acumulado",
  "Net cash + banks": "Efectivo neto + bancos",
  "Cash + operating banks (1010/1020)": "Efectivo + bancos operativos (1010/1020)",
  "Open purchase-order commitments": "Compromisos de órdenes de compra abiertas",
  "Leading indicator of future spend": "Indicador adelantado del gasto futuro",
  "Top 5 by open balance": "Top 5 por saldo abierto",
  "<30% concentration": "<30% concentración",
  "No AR balances": "Sin saldos de CxC",
  "Leading SetID by revenue (geographic mix)": "SetID líder por ingresos (mezcla geográfica)",
  "No data": "Sin datos",
  "Open internal-audit findings": "Hallazgos abiertos de auditoría interna",
  "<5 · 0 MW": "<5 · 0 DM",
  "Operating footprint + active users": "Huella operativa + usuarios activos",
  "Active business units and system users": "Unidades de negocio activas y usuarios del sistema",
  "Fiscal-year close progress": "Avance del cierre del ejercicio",
  ">90% at close": ">90% al cierre",
  "(AR / Revenue YTD) × 365": "(CxC / Ingresos acumulados) × 365",
  "<45 days": "<45 días",
  "Days payable outstanding": "Días de pago pendientes",
  "30–60 days": "30–60 días",
  "Cash conversion cycle": "Ciclo de conversión de efectivo",
  "<30 days": "<30 días",
  "Current assets − current liabilities": "Activo corriente − pasivo corriente",
  "Short-term liquidity buffer": "Colchón de liquidez de corto plazo",
  "Current assets / current liabilities": "Activo corriente / pasivo corriente",
  "Liquidity coverage": "Cobertura de liquidez",
  "No budget ledger loaded": "Sin libro de presupuesto cargado",
  "Actual vs BUDGET ledger": "Real vs libro PRESUPUESTO",
  "Net inflows − outflows, 13 weeks": "Entradas − salidas netas, 13 semanas",
  "Short-term treasury forecast": "Pronóstico de tesorería de corto plazo",
  "Effective tax rate — not loaded": "Tasa efectiva de impuesto — no cargada",
  "ETR from tax provision": "TEI de la provisión de impuestos",
  "{closed} / {total} findings closed": "{closed} / {total} hallazgos cerrados",
  "Internal-audit remediation": "Remediación de auditoría interna",
  ">90% · 0 MW": ">90% · 0 DM",
  "Receivables overdue > 60 days": "CxC vencidas > 60 días",
  "CECL provision rises on +60d": "La provisión CECL sube sobre +60d",
  "Payables overdue > 60 days": "CxP vencidas > 60 días",
  "Vendor & legal risk on +60d": "Riesgo de proveedor y legal sobre +60d",
  "SOX 404 disclosure": "Divulgación SOX 404",
  "None identified": "Ninguna identificada",
  "SOX §404 material weaknesses": "Debilidades materiales SOX §404",
  "YTD {ytd} · {n} invoices": "Acum. {ytd} · {n} facturas",
  "Rev {rev} − Exp {exp}": "Ing. {rev} − Gasto {exp}",
  "#1 {id} · {pct}% of total AR": "#1 {id} · {pct}% del total CxC",
  "{rev} leading region": "{rev} región líder",
  "{n} Material Weakness — SOX 404": "{n} debilidad material — SOX 404",
  "{n} open findings": "{n} hallazgos abiertos",
  "{n} / 12 periods closed": "{n} / 12 períodos cerrados",
  "AR {ar} / Rev YTD": "CxC {ar} / Ing. acum.",
  "AP {ap} / COGS est.": "CxP {ap} / costo de ventas est.",
  "DSO {dso} + DIO {dio} − DPO {dpo}": "DSO {dso} + DIO {dio} − DPO {dpo}",
  "Operating margin {pct}% below the sector benchmark (>20%). Review operating expense.": "Margen operativo {pct}% bajo el referente del sector (>20%). Revisar el gasto operativo.",
  "Top-1 customer concentration {pct}% > 30% — single-customer dependence risk.": "Concentración del cliente top-1 {pct}% > 30% — riesgo de dependencia de un solo cliente.",
  "{n} Material Weakness identified — 10-K SOX 404 disclosure required.": "{n} debilidad material identificada — se requiere divulgación 10-K SOX 404.",
  "Cash position {amt} below the $50K threshold — activate a 13-week forecast.": "Posición de caja {amt} bajo el umbral de $50K — activar un pronóstico a 13 semanas.",
  "Pipeline {pl} > Revenue YTD {rev} — strong leading indicator.": "Pipeline {pl} > Ingresos acum. {rev} — fuerte indicador adelantado.",
  "DSO {n}d above the 45-day target — accelerate collections.": "DSO {n}d sobre el objetivo de 45 días — acelerar la cobranza.",
  "Cash conversion cycle {n}d above the 30-day target — working capital tied up in operations.": "Ciclo de conversión de efectivo {n}d sobre el objetivo de 30 días — capital de trabajo atado en operaciones.",
  "Negative cash conversion cycle ({n}d) — operations financed by suppliers. Strong position.": "Ciclo de conversión de efectivo negativo ({n}d) — operaciones financiadas por proveedores. Posición sólida.",
  "Current ratio {n} below 1.0 — current liabilities exceed current assets; liquidity watch.": "Razón corriente {n} bajo 1.0 — el pasivo corriente supera al activo corriente; alerta de liquidez.",
  "{n} Material Weakness open — 10-K SOX 404 disclosure required.": "{n} debilidad material abierta — se requiere divulgación 10-K SOX 404.",
  "{amt} of receivables overdue >60 days — CECL provision rises sharply on these buckets.": "{amt} de CxC vencidas >60 días — la provisión CECL sube fuertemente en estos tramos.",
  "Period-end AP accrual": "Devengo de CxP de fin de período",
  "Identify receipts without a voucher; create an auto-reversing accrual journal.": "Identificar recepciones sin comprobante; crear un asiento de devengo con auto-reverso.",
  "Revenue accrual (BI/AR)": "Devengo de ingresos (Fact./CxC)",
  "Bills invoiced for future service → deferred-revenue journal (2210).": "Facturas emitidas por servicio futuro → asiento de ingreso diferido (2210).",
  "Subledger vs GL reconciliation": "Conciliación submayor vs mayor",
  "Compare AR/AP/Bank subledger to GL; report variances > $0.01.": "Comparar submayor CxC/CxP/Banco con el mayor; reportar variaciones > $0.01.",
  "Bank reconciliation (BAI2)": "Conciliación bancaria (BAI2)",
  "Import a BAI2 statement; match payments; update RECONCILED_FLAG.": "Importar un estado BAI2; conciliar pagos; actualizar RECONCILED_FLAG.",
  "Year-end close": "Cierre de fin de año",
  "Close P&L; zero-out I/E accounts to Retained Earnings (3110).": "Cerrar resultados; saldar cuentas de ingreso/gasto contra Utilidades Retenidas (3110).",
  "PR regulatory reporting": "Reportes regulatorios PR",
  "SC 2918 (monthly IVU), SC 2070 (480.6 withholding), SURI returns.": "SC 2918 (IVU mensual), SC 2070 (retención 480.6), declaraciones SURI.",
  "SoD exceptions": "Excepciones de SoD",
  "Users with segregation-of-duties conflicts in the period, for internal audit.": "Usuarios con conflictos de segregación de funciones en el período, para auditoría interna.",

  // ── WorkCenter ──
  "Consolidated panel · work queues, quick links and period summary.": "Panel consolidado · colas de trabajo, enlaces rápidos y resumen del período.",
  "My Work": "Mi trabajo",
  "Budget Exceptions": "Excepciones presupuestales",
  "Pending Approval": "Pendientes de aprobación",
  "ChartField Requests": "Solicitudes de ChartField",
  "Pending Reconciliations": "Conciliaciones pendientes",
  "Errors (Edit)": "Errores (Edición)",
  "Quick Links": "Enlaces rápidos",
  "Period Summary": "Resumen del período",
  "No pending journals.": "Sin asientos pendientes.",
  "No budget exceptions.": "No hay excepciones presupuestales.",
  "No journals pending your approval.": "Sin asientos pendientes de tu aprobación.",
  "No pending changes.": "Sin cambios pendientes.",
  "No accounts assigned.": "No tienes cuentas asignadas.",
  "No errors.": "Sin errores.",
  "Total journals": "Asientos totales",
  "Posted": "Contabilizados",
  "Draft / In Edit": "Borrador / En edición",
  "With errors": "Con errores",
  "+ New Journal": "+ Nuevo asiento",
  "Journals Inbox": "Bandeja de asientos",
  "Ledger Inquiry": "Consulta del mayor",
  "Accounting Periods": "Períodos contables",
  "Import Journals (Excel)": "Importar asientos (Excel)",
  "User Manual": "Manual de usuario",

  // ── GL hub link names + descriptions ──
  "Business Units": "Unidades de negocio",
  "Create and maintain Business Units": "Alta y mantenimiento de unidades de negocio",
  "Accounting Ledgers": "Libros contables",
  "Define ledgers and ledger groups": "Definir libros y grupos de libros",
  "Chart of Accounts": "Plan de cuentas",
  "Create and maintain accounts": "Alta y mantenimiento de cuentas",
  "ChartFields": "ChartFields",
  "Accounting dimensions configuration": "Configuración de dimensiones contables",
  "Fiscal Calendars": "Calendarios fiscales",
  "Accounting periods definition": "Definición de períodos contables",
  "Exchange Rates": "Tipos de cambio",
  "Exchange rate tables and revaluation": "Tablas de tipo de cambio y revaluación",
  "Journal Sources": "Orígenes de asiento",
  "Journal Source definitions": "Definiciones de origen de asiento",
  "Journal Classes": "Clases de asiento",
  "Accounting journal types and classes": "Tipos y clases de asiento contable",
  "Approval Options": "Opciones de aprobación",
  "Journal authorization workflow": "Flujo de autorización de asientos",
  "Journal Entry": "Captura de asiento",
  "Create and edit manual journals": "Crear y editar asientos manuales",
  "Standard Journals": "Asientos estándar",
  "Recurring journals and templates": "Asientos recurrentes y plantillas",
  "Import Journals": "Importar asientos",
  "Bulk load from flat file or Excel": "Carga masiva desde archivo plano o Excel",
  "Edit Journals": "Editar asientos",
  "Validation process (Edit)": "Proceso de validación (Edición)",
  "Post Journals": "Contabilizar asientos",
  "Posting process": "Proceso de contabilización",
  "Unpost Journals": "Descontabilizar asientos",
  "Posting reversal": "Reverso de contabilización",
  "Approve Journals": "Aprobar asientos",
  "Approval inbox": "Bandeja de aprobación",
  "Journal Inquiry": "Consulta de asientos",
  "Search and inquire journals": "Buscar y consultar asientos",
  "Configure Rules": "Configurar reglas",
  "Account reconciliation rules": "Reglas de conciliación de cuentas",
  "Reconciliation Workbench": "Mesa de trabajo de conciliación",
  "Interactive reconciliation management": "Gestión interactiva de conciliación",
  "Create Reconciliations": "Crear conciliaciones",
  "Generate reconciliations": "Generar conciliaciones",
  "Revaluation": "Revaluación",
  "FX balance revaluation process": "Proceso de revaluación de saldos en ME",
  "Translation": "Conversión",
  "Ledger translation process": "Proceso de conversión del libro",
  "Average Balances": "Saldos promedio",
  "ADB (Average Daily Balance) calculation": "Cálculo de saldo diario promedio (ADB)",
  "Configure Consolidation": "Configurar consolidación",
  "Trees, scopes, eliminations": "Árboles, alcances, eliminaciones",
  "Execute Consolidation": "Ejecutar consolidación",
  "Consolidation process": "Proceso de consolidación",
  "Consolidation Dashboard": "Tablero de consolidación",
  "Process monitoring": "Monitoreo de procesos",
  "Closing Rules": "Reglas de cierre",
  "Closing rules configuration": "Configuración de reglas de cierre",
  "Interim Close": "Cierre intermedio",
  "Monthly period close": "Cierre de período mensual",
  "Year-End Close": "Cierre de fin de año",
  "Fiscal year-end close": "Cierre del ejercicio fiscal",
  "Undo Close": "Deshacer cierre",
  "Close reversal": "Reverso de cierre",
  "Balance Sheet": "Balance general",
  "Statement of Financial Position": "Estado de situación financiera",
  "Income Statement": "Estado de resultados",
  "Profit & Loss report": "Reporte de pérdidas y ganancias",
  "Cash Flow": "Flujo de efectivo",
  "Statement of Cash Flows": "Estado de flujos de efectivo",
  "Trial Balance": "Balanza de comprobación",
  "General Trial Balance": "Balanza de comprobación general",
  "General Ledger": "Libro mayor",
  "Account movement detail": "Detalle de movimientos de cuenta",
  "Accounting Journals": "Asientos contables",
  "Journal listing and detail": "Listado y detalle de asientos",
  "Interactive balances by dimension": "Saldos interactivos por dimensión",
  "Posted journal detail": "Detalle de asientos contabilizados",
  "Period Comparison": "Comparación de períodos",
  "Period-over-period balance comparison": "Comparación de saldos período a período",
  "PR Compliance Hub": "Centro de cumplimiento PR",
  "IVU · 480 · License · CRIM · Act 60": "IVU · 480 · Licencia · CRIM · Ley 60",
  "SC 2918 — Monthly IVU": "SC 2918 — IVU mensual",
  "Monthly sales-tax return to Hacienda": "Declaración mensual de IVU a Hacienda",
  "Form 480.20 Corp": "Forma 480.20 Corp",
  "Income tax + surtax + AMT": "Contribución sobre ingresos + sobretasa + AMT",
  "Form 480.6 A/B/C": "Forma 480.6 A/B/C",
  "Annual withholding informational returns": "Declaraciones informativas anuales de retención",
  "Municipal License": "Patente municipal",
  "Form 2A annual per municipality": "Forma 2A anual por municipio",
  "CRIM AS-29": "CRIM AS-29",
  "Personal and real property": "Propiedad mueble e inmueble",
  "Schedule M-1": "Anejo M-1",
  "Book/tax reconciliation": "Conciliación libro/fiscal",
  "Act 60 Decrees": "Decretos Ley 60",
  "Compliance + annual fee tracking": "Cumplimiento + seguimiento de cuota anual",
  "Filings Audit Trail": "Rastro de auditoría de radicaciones",
  "Tamper-evident history": "Historial a prueba de manipulación",
  "Open/Close Periods": "Abrir/cerrar períodos",
  "Period opening control": "Control de apertura de períodos",
  "Process Monitor": "Monitor de procesos",
  "Batch process status": "Estado de procesos por lotes",
  "Audit Logs": "Bitácoras de auditoría",
  "Change and access history": "Historial de cambios y accesos",
} as Record<string, string>;
